import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=0a4503eb&scoped=true&"
import script from "./Lesson.vue?vue&type=script&lang=ts&"
export * from "./Lesson.vue?vue&type=script&lang=ts&"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=0a4503eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4503eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a4503eb', component.options)
    } else {
      api.reload('0a4503eb', component.options)
    }
    module.hot.accept("./Lesson.vue?vue&type=template&id=0a4503eb&scoped=true&", function () {
      api.rerender('0a4503eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/lessons/lesson/Lesson.vue"
export default component.exports